import { useMemo } from "react";
import { useCourseIndexRoute } from "@tecnobit-srl/route-types-course-index/lazy";
import { useMyCourseIndexRoute } from "@tecnobit-srl/route-types-my-course-index/lazy";
import { useMyCourseRoute } from "@tecnobit-srl/route-types-my-course/lazy";
import { useMyCourseLessonRoute } from "@tecnobit-srl/route-types-my-course-lesson/lazy";
import { useMyCourseQuizRoute } from "@tecnobit-srl/route-types-my-course-quiz/lazy";
//#region src/index.ts
var useCoursesRouteTypes = () => {
	const courseIndexRoute = useCourseIndexRoute();
	const myCourseIndexRoute = useMyCourseIndexRoute();
	const myCourseRoute = useMyCourseRoute();
	const myCourseLessonRoute = useMyCourseLessonRoute();
	const myCourseQuizRoute = useMyCourseQuizRoute();
	return useMemo(() => ({
		...courseIndexRoute,
		...myCourseIndexRoute,
		...myCourseRoute,
		...myCourseLessonRoute,
		...myCourseQuizRoute
	}), [
		courseIndexRoute,
		myCourseIndexRoute,
		myCourseRoute,
		myCourseLessonRoute,
		myCourseQuizRoute
	]);
};
//#endregion
export { useCoursesRouteTypes };
